// extracted by mini-css-extract-plugin
module.exports = {"EasyPenMobile":"_2r69VKSnz0QnZczMhpUvR"};